import {FunctionComponent, ReactNode, useEffect} from "react";
import {FormSection} from "../molecules/formSection";
import {ChangePageHeader} from "../organisms/changePageHeader";

interface ChangeFormTemplateProps {
    disableMinHeight?: boolean;
    loading?: boolean;
    modalComponent?: ReactNode;
    enableModal?: boolean;
}

export const ChangeFormTemplate: FunctionComponent<ChangeFormTemplateProps> =
    ({
         children,
         disableMinHeight = false,
         loading = false,
         modalComponent,
         enableModal = false
     }) => {
        useEffect(() => {
            if (enableModal) {
                document.body.style.overflowY = 'hidden';
            } else {
                document.body.style.overflowY = 'initial';
            }
        }, [enableModal])

        return (
            <>
                {enableModal ? (
                    <div
                        className={'fixed top-0 h-full w-full bg-[#9A9A9A] bg-opacity-[80%] backdrop-blur z-[100] transition duration-700 flex justify-center items-center overflow-auto'}>
                        {modalComponent}
                    </div>
                ) : null}
                <div className={'max-w-screen-lg mx-auto'}>
                    <ChangePageHeader/>
                    <FormSection disableMinHeight={disableMinHeight} loading={loading}>{children}</FormSection>
                </div>
            </>
        )
    };
